import { useMemo } from 'react';

import { useContentfulContentTypeEntryFactory } from '@sg/shared-fe/integrations/contentful';

import type { ContentfulClientApi } from 'contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useUpsellContent = (params: Params) => {
  const { contentfulClient, pause } = params;

  const { data, fetching } = useContentfulContentTypeEntryFactory<ContentfulUpsellContentFields>({
    contentfulClient,
    contentType: 'upsell',
    pause,
  });

  const isFetching = fetching && !data;

  const mappedContent = useMemo<ContentfulUpsellContentFields>(
    () => mapContent(data?.fields),
    [data?.fields],
  );

  return { isFetching, mappedContent };
};

// ─────────────────────────────────────────────────────────────────────────────

function mapContent(fields: ContentfulUpsellContentFields | undefined) {
  if (!fields) return FALLBACK_DATA;

  const { upsellCta } = fields;

  return {
    upsellCta,
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

const FALLBACK_DATA: ContentfulUpsellContentFields = {
  upsellCta: 'Complete your meal with...',
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  pause: boolean;
  contentfulClient: ContentfulClientApi | undefined;
};

export type ContentfulUpsellContentFields = {
  upsellCta: string;
};
